import React, { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../common/atoms';
import { PeriodPicker } from '../common/molecules';
import { utilizationApi } from '../../services';
import { RatingsManager, UtilizationGraphManager, ContractsManager, WalletUtilizationManager  } from '../../managers';
import { MetricManager, CommentsManager } from '../../managers/Fitness';
import { handleAppError, setLocalStorage } from '../handlers';
import { UtilizationLockScreen, NoUtilizationCard } from '../common/organisms';
import { GymAndFitnessLocked, FitnessLow } from '../../assets/images';
import { FITNESS_LOCKED_CONTENT, TOTAL_GYMS } from '../../constants/utilization';
import {GymAndFitness} from '../common/templates/Utilization';
import moment from 'moment';
import DateRangePicker from '../tailwind/molecules/DateRangePicker';
import { SALES_ROLE } from '../../constants/overview';
import { dsButtonPrimary, joinButtonClasses } from '../../utils/buttonStyles';
let token = '';

class GymAndFitnessPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      ratingObj: {},
      commentsObj: {},
      utilizationObj: {},
      walletUtilizationObj: {},
      benefitName: 'gym',
      loading: true,
      showNoUtilization: false,
      show_lock_screen: false,
      filterDates: {startDate: null, endDate: null}
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    this.setState({loading : true});
    this.setState({loading: true })
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date =  moment(start_date).format('YYYY-MM-DD')
    end_date =  moment(end_date).format('YYYY-MM-DD')

    var promise1 = utilizationApi.fitnessFetchMetrics({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise2 = utilizationApi.fitnessFetchRatings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise3 = utilizationApi.fitnessFetchComments({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise4 = utilizationApi.fitnessFetchUtilization({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise5 = utilizationApi.walletBenefitUtilization({ contractId, benefit_type : 'fitness', startDate: start_date, endDate: end_date })
    Promise.all([promise1, promise2, promise3, promise4, promise5])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = new MetricManager(resp_arr[0]);
        setLocalStorage(TOTAL_GYMS, metricObj.total);
        var ratingObj = new RatingsManager(resp_arr[1]);
        var commentsObj = new CommentsManager(resp_arr[2]);
        var utilizationObj = new UtilizationGraphManager(resp_arr[3]);
        var showNoUtilization = metricObj.total_session_utilized === 0;
        var walletUtilizationObj = new WalletUtilizationManager(resp_arr[4]);
        walletUtilizationObj.xAxesLabelWallet = 'Months';

        this.setState({
          metricObj,
          ratingObj,
          commentsObj,
          utilizationObj,
          loading: false,
          showNoUtilization,
          show_lock_screen: !metricObj.total_sposored_session,
          walletUtilizationObj
        });
      })
      .catch((err) => handleAppError(err));
  };

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        const contractObj = new ContractsManager(resp.data);
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          totalCustomers: contractObj.formattedData[0].total_customers,
          filterDates: { startDate: contractObj.formattedData[0]?.start_date, endDate: contractObj.formattedData[0]?.end_date }
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.state.contractId && prevState.contractId !== this.state.contractId)|| (this.state.filterDates.startDate && prevState.filterDates.startDate !== this.state.filterDates.startDate) || (this.state.filterDates.endDate && prevState.filterDates.endDate !== this.state.filterDates.endDate)) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate);
    }
  }

  toggleHelp = () => this.props.toggleHelp('Gyms_&_Fitness');

  content = (selectedContractObj) => {
    const { loading, showNoUtilization, show_lock_screen } = this.state;

    if (loading || (selectedContractObj.enable_gym && !show_lock_screen)) {
      return showNoUtilization ? (
        <NoUtilizationCard
          line='utilization of the workout sessions provided by the company'
          imgsrc={FitnessLow}
          toggleHelp={this.toggleHelp}
          classes='mt-8'
        />
      ) : (
        <GymAndFitness {...this.state} />
      );
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Gyms and Fitness is not sponsored'
            image={GymAndFitnessLocked}
            sectionSubtitle='Benefits to your employees'
            points={FITNESS_LOCKED_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        selectedContractObj: contract,
        metricObj: {},
        ratingObj: {},
        commentsObj: {},
        utilizationObj: {},
        walletUtilizationObj: {},
        benefitName: 'gym',
        loading: true,
        showNoUtilization: false,
        filterDates: {startDate: contract?.start_date, endDate: contract?.end_date}
      });
    }
  };

  changeDates = (e, date_type) =>{
    let date = moment(e).format('YYYY-MM-DD')
    if (e){
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: date}})
      }
      else if(date_type === 'endDate') {
        this.setState({filterDates: {...this.state.filterDates, endDate: date}})
      }
      else if(date_type === 'reset'){
        this.setState({filterDates: {startDate: moment(this.state.selectedContractObj?.start_date)}, endDate: moment(this.state.selectedContractObj?.end_date)})
      }
    }
    else{
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: moment(this.state.selectedContractObj.start_date).format('YYYY-MM-DD')}})
      }
      else {
        this.setState({filterDates: {...this.state.filterDates, endDate: moment(this.state.selectedContractObj.end_date).format('YYYY-MM-DD')}})
      }
    }
  };

  navigateToActivityLog = () => {
    var filteredContract = this.state.contractObj.data.filter((contract)=> (contract.id === this.state.contractId));
    if (filteredContract.length > 0) {
      var { id, start_date, end_date } = filteredContract[0]
      this.props.history.push('/activity-log?point=fitness', { contract_id: id, start_date, end_date });
    }else {
      var { id, start_date, end_date} = this.state.contractObj.data[0]
      this.props.history.push('/activity-log?point=fitness', { contract_id: id, start_date, end_date });  
    }
  };

  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;
    return (
      <div className='min-w-0'>
        <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
          <div className='min-w-0'>
            <Breadcrumb
              list={[
                { text: 'Utilization', link: '/utilization/ahc' },
                { text: 'Gyms and Fitness', link: '/gym-and-fitness' },
              ]}
              classes='mb-1'
            />
            {typeof this.state.selectedContractObj !== 'undefined' && (
              <Heading
                mainHeading='Utilization of Gyms and Fitness'
                mainClasses='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'
              />
            )}
          </div>
          <div className='flex shrink-0 flex-wrap items-end gap-2 lg:justify-end'>
            {/* Period control joins the existing action group, bottom-aligned so the control and the button
                share a baseline. The separate "Contract period / year" caption is gone with it: the picker
                states that itself. */}
            <PeriodPicker
              list={formattedData}
              loading={loading}
              currentPage={this.state.selectedContractObj?.text}
              setContract={this.changeContractId}
            />
            <button
              type='button'
              onClick={this.navigateToActivityLog}
              disabled={SALES_ROLE === 'sales' }
              className={joinButtonClasses(dsButtonPrimary, 'h-10 px-5', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
            >
              Activity Log
            </button>
          </div>
        </div>
        {contractObj && (
          <div className='mt-3'>
            <DateRangePicker
              filterDates={this.state.filterDates}
              contractDates={[this.state.selectedContractObj?.start_date, this.state.selectedContractObj?.end_date]}
              changeDates={this.changeDates}
            />
          </div>
        )}
        {this.content(this.state.selectedContractObj)}
      </div>
    );
  }
}

export default GymAndFitnessPage;
